import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {pairwise, startWith} from "rxjs/operators";

@Component({
    selector: 'app-warehouse-final-preview',
    templateUrl: './warehouse-final-preview.component.html',
    styleUrls: ['./warehouse-final-preview.component.scss'],
    standalone: false
})
export class WarehouseFinalPreviewComponent implements OnInit {

  @Input() model: any = {};
  @Input() form: any = {};
  @Output() callback = new EventEmitter<any>(true);

  public warehouse: any = {};
  public wareHouseDetail: any = {};



  constructor() { }

  ngOnInit(): void {

    this.model = this.model?.model;
    this.warehouse =   this.form.get('step01').get('wareHouse').getRawValue();
    this.wareHouseDetail =  this.form.get('step02').get('wareHouseDetail').getRawValue();
    console.log('this.model ware house finl' ,  this.form.get('step02').get('wareHouseDetail').getRawValue());


    // this.form.get('step01').valueChanges
    //   .pipe(startWith(null), pairwise())
    //   .subscribe(([prev, next]: [any, any]) => {
    //     this.warehouse = next ?.wareHouse;
    //     console.log(this.warehouse);
    //   });
    //
    // this.form.get('step02').valueChanges
    //   .pipe(startWith(null), pairwise())
    //   .subscribe(([prev, next]: [any, any]) => {
    //     this.wareHouseDetail = next ?.wareHouseDetail;
    //     console.log(this.wareHouseDetail);
    //   });

  }


}
